// Angular demo examples
import { code } from "@spscommerce/utils";

export const SpsDateRangePickerExamples = {
    basic: {
        label: "Basic",
        description: code`<p>info about basic date-range-picker</p>`,
        examples: {
            basic: {
                template: code`
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-3">
                                <sps-date-range-picker aria-label="Choose a date range" formControlName="dateRange" id="dateRangeBasic"></sps-date-range-picker>
                            </div>
                        </div>
                        <br />
                        selected date range (serialized from moment objects):<br />
                        {{ form.get("dateRange").value | json }}
                    </form>
                `,
                class: code`
                    class DemoComponent {
                        form: FormGroup;
                        constructor(fb: FormBuilder) {
                            this.form = fb.group({
                                dateRange: []
                            });
                        }
                    }
                `
            }
        }
    },
    minMax: {
        label: "Min Max",
        description: code`<p>info about date-range-picker with min and max dates</p>`,
        examples: {
            basic: {
                template: code`
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-3">
                                <sps-date-range-picker aria-label="Choose a date range" formControlName="dateRangeMinMax"
                                    minDate="2018-02-04"
                                    maxDate="2018-04-15">
                                </sps-date-range-picker>
                            </div>
                        </div>
                    </form>
                `,
                class: code`
                    class DemoComponent {
                        form: FormGroup;
                        constructor(fb: FormBuilder) {
                            this.form = fb.group({
                                dateRangeMinMax: []
                            });
                        }
                    }
                `
            }
        }
    },
    disabled: {
        label: "Disabled",
        description: code`<p>info about disabled date-range-picker</p>`,
        examples: {
            basic: {
                template: code`
                    <!-- Disabled via Reactive Forms -->
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-3">
                                <sps-date-range-picker aria-label="Choose a date range" formControlName="dateRangeDisabled" id="dateRangeDisabled">
                                </sps-date-range-picker>
                            </div>
                        </div>
                    </form>
                `,
                class: code`
                    class DemoComponent {
                        form: FormGroup;
                        constructor(fb: FormBuilder) {
                            this.form = fb.group({
                                dateRangeDisabled: [
                                    {
                                        value: {
                                            start: moment().subtract(2, "days"),
                                            end: moment()
                                        },
                                        disabled: true
                                    }
                                ]
                            });
                        }
                    }
                `
            }
        }
    },
    withLabel: {
        label: "With Label",
        description: code`<p>info about date-range-picker with label</p>`,
        examples: [{
            template: code`
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-3">
                            <sps-label for="dateRangeWithLabel">Date Range</sps-label>
                            <sps-date-range-picker formControlName="dateRangeWithLabel">
                            </sps-date-range-picker>
                        </div>
                    </div>
                </form>
            `,
            class: code`
                class DemoComponent {
                    form: FormGroup;
                    constructor(fb: FormBuilder) {
                        this.form = fb.group({
                            dateRangeWithLabel: [
                                {
                                    start: null,
                                    end: null,
                                    preset: { days: 7 }
                                },
                                Validators.required
                            ]
                        });
                    }
                }
            `
        }]
    },
    customPresets: {
        label: "Custom Presets",
        description: code`<p>info about custom preset date-range-picker</p>`,
        examples: [{
            template: code`
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-3">
                            <sps-date-range-picker aria-label="Choose a date range" [availablePresets]="customPresets"
                            formControlName="dateRangeCustomPresets">
                            </sps-date-range-picker>
                        </div>
                    </div>
                    <br />
                    selected date range (serialized from moment objects):<br />
                    {{ form.get("dateRangeCustomPresets").value | json }}
                </form>
            `,
            class: code`
                class DemoComponent {
                    form: FormGroup;
                    constructor(fb: FormBuilder) {
                        this.form = fb.group({
                            dateRangeCustomPresets: []
                        });
                    }
                    customPresets = [{hours : 8},{ days: 1 },{ days: 5 }, { days: 37 }, { months: 8 }, { years: 2000 }];
                }
            `
        }]
    }
};
